"use client";

import Image from "next/image";
import { useFooterMessages } from "@/i18n/hooks/useFooterMessages";

export default function FooterFooter() {
  const m = useFooterMessages();

  return (
    <div className="flex flex-wrap-reverse justify-between">
      <p className="text-primary-foreground text-[1rem]">
        {m.copyright(new Date().getFullYear())}
        <br />
        <span>| 深圳市恒宇博科技有限公司</span>
      </p>
      <div className="flex gap-1">
        <a
          href="https://itunes.apple.com/us/app/edx/id945480667?mt=8&amp;external_link=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src="/images/apple-store-badge-en.png"
            alt={m.appStoreAlt}
            title={m.appStoreTitle}
            width={120}
            height={40}
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=org.edx.mobile&amp;external_link=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src="/images/google-play-badge-en.png"
            alt={m.googlePlayAlt}
            title={m.googlePlayTitle}
            width={135}
            height={40}
          />
        </a>
      </div>
    </div>
  );
}
